import './i18n';
import React from 'react';
import ReactDOM from 'react-dom'; // React 17 — using ReactDOM.render
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/animate.min.css';
import './assets/scss/light-bootstrap-dashboard-react.scss?v=2.0.0';
import './assets/css/demo.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import { ThemeProvider } from './context/ThemeContext';
import './Themes/themes.css'; // fixed: was incorrectly '../src/Themes/themes.css'
import './App.css'; // fixed: was incorrectly '../src/Themes/themes.css'

// ─── Components ───────────────────────────────────────────────────────────────
import './components/SidebarNew.css';
import './components/Sidemenu.css';
import './components/IframeViewer.css';

// ─── Shared ───────────────────────────────────────────────────────────────────
import './shared/CustomToast/customToast.css';
import './shared/CustomModal/CustomModal.scss';
import './shared/Loader/Loader.scss';
import './shared/Notifications/Notification.scss';
import './shared/Pagination/Pagination.scss';
import './shared/Pagination/PaginationDiffPage.scss';
import './shared/ConfirmModal/ConfirmModal.scss';

// ─── Screens ──────────────────────────────────────────────────────────────────
import './screens/Login/loginScreen.css';
import './screens/ForgotPassword/forgotPassword.css';
import './screens/Dashboard/SlidingDiv.css';
import './screens/Dashboard/DashBoardView/NewDashboard.css';
import './screens/Dashboard/DashBoardView/DashboardView.css';
import './screens/Dashboard/DashboardCreateWidget/Dashboard.css';
import './screens/Dashboard/FilterDashboard.scss';
import './screens/ActionTable/ActionTableBuilder.scss';
import './screens/Allocation/Allocation.scss';
import './screens/CustomForms/AvtCustomForms/AvtCustom.scss';
import './screens/CustomForms/Efl custom forms/Efl custom.scss';
import './screens/CustomForms/Efl custom forms/GridComponent.scss';
import './screens/DataUpload/Dataupload.scss';
import './screens/MasterDataUploadNew/MasterDataUpload.scss';
import './screens/FormBuilder/FormBuilder.css';
import './screens/FormSubmissions/FormSubmission.css';
import './screens/FormSubmissions/Submission.scss';
import './screens/FormSubmissions/popupModal.css';
import './screens/FormSubmissions/ImagePopup.scss';
import './screens/FormSubmissions/DynamicGrid.scss';
import './screens/Workflow/Workflow.scss';
import './screens/RolesandPermission/RolesandPermission.scss';
import './screens/ResetPassword/ResetPassword.scss';
import './screens/Project/ProjectHomeOverView.scss';
import './screens/Organization/Organization.scss';
import './screens/GeneralSettings/generalsettings.scss';
import './screens/Audit-log/Audit-log.scss';
import './assets/scss/style.scss';

// Suppress the benign ResizeObserver loop notification that Recharts triggers.
// It is not an application error — the browser fires it when a ResizeObserver
// callback causes a resize before the current paint frame finishes. Recharts'
// ResponsiveContainer does this by design and it has no visible side-effect.
window.addEventListener('error', (e) => {
    if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
        e.message === 'ResizeObserver loop limit exceeded') {
        e.stopImmediatePropagation();
    }
}, true);

// MUI Pro license key — loaded from environment variable, never hardcoded in source
// Set REACT_APP_MUI_LICENSE_KEY in your CI/CD secrets (GitLab CI variables)
if (process.env.REACT_APP_MUI_LICENSE_KEY) {
    import('@mui/x-license').then(({ LicenseInfo }) => {
        LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY);
    });
}

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </BrowserRouter>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// ─── Web Vitals ───────────────────────────────────────────────────────────────
// Sends Core Web Vitals to the console in development so developers see them
// immediately.  Replace with your analytics sink (GA4, Datadog, etc.) for
// production: reportWebVitals((m) => sendToAnalytics(m))
const sendWebVitals = (metric) => {
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.info('[WebVital]', metric.name, Math.round(metric.value), metric.rating);
    }
    // TODO: forward to your analytics provider in production, e.g.:
    // fetch('/api/vitals', { method: 'POST', body: JSON.stringify(metric) });
};
reportWebVitals(sendWebVitals);